import React from 'react';

import Layout from '../components/Layout';
import Footer from '../components/Footer';
import Header from '../components/Header';
import EmailForm from '../components/EmailForm';
import SlideShow from '../components/SlideShow';

var settings = {
  images: [
    { url: require('../assets/images/bg01.webp'), position: 'center' },
    { url: require('../assets/images/bg02.webp'), position: 'center' },
    { url: require('../assets/images/bg03.webp'), position: 'center' },
    { url: require('../assets/images/bg04.webp'), position: 'center' },
    { url: require('../assets/images/bg05.webp'), position: 'center' },
    { url: require('../assets/images/bg06.webp'), position: 'center' },
    { url: require('../assets/images/bg07.webp'), position: 'center' },
    { url: require('../assets/images/bg08.webp'), position: 'center' },
    { url: require('../assets/images/bg09.webp'), position: 'center' },
    { url: require('../assets/images/bg10.webp'), position: 'center' },
  ],
  // Delay.
  delay: 6000,
};

const IndexPage = () => (
  <Layout>
    <Header />
    <EmailForm />
    <Footer />
    <SlideShow settings={settings} />
  </Layout>
);

export default IndexPage;
